import React from 'react';
import { Globe } from 'lucide-react';

// DomainStatusCompact — Sprint D item 3.6.
// Renders only when account owns a NexSav-managed domain (nexsav_purchased=1).
// One line: "Your domain expires DATE."

function formatDate(s) { return s ? s.slice(0, 10) : null; }

export default function DomainStatusCompact({ domain }) {
  if (!domain || domain.nexsav_purchased !== 1) return null;
  const expires = formatDate(domain.expires_at);
  return (
    <div data-testid="domain-status-compact" className="rounded-2xl border border-white/[0.06] bg-white/[0.02] p-4 flex items-center gap-3">
      <Globe className="w-4 h-4 text-gray-400 shrink-0" />
      <div className="text-[12px] text-gray-300 flex-1">
        <span className="font-medium text-white">{domain.name}</span>
        {expires && <span className="ml-2 text-gray-500">expires {expires}</span>}
      </div>
    </div>
  );
}
